
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Group from 'vux/src/components/group/index.vue'

export default {
name: "verphonenum",
components: {
XHeader, XInput,Group
},
data() {
return {
phone:'',
vercode:'',
stunum:'',
isright: function (value) {
return {
valid: /^[0-9a-zA-Z]*$/g.test(value),
msg: '请输入字母或者数字'
}
},
}
},
mounted(){
this.stunum = this.$store.state.stu_num;
this.phone='18792783901';
},
methods:{
setNew(){
this.$router.push({name: 'newphonenum', params: {stunum: this.stunum}})
},
}
}



// WEBPACK FOOTER //
// ./src/components/VerPhoneNum.vue